import type { ApiResponseScheduleOfInvestments } from "@vega-api/generated/types/apiResponseScheduleOfInvestments";

export const mockSOIdata: NonNullable<
  ApiResponseScheduleOfInvestments["data"]
> = {
  realized: [
    {
      category: "Private Buyout",
      holdings: [
        {
          id: "fa00aa6f-fc0e-42cb-bb13-8e26cdf9f59f",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "DEAL",
          dealType: "Distressed buyout",
          name: "Vallourec",
          initialInvestmentDate: "2021-06-30",
          totalInvestedCapital: {
            id: "58721401-0e60-4e93-97d8-1eb5e60de3a2",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 289417130,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "a4511019-f528-456e-9f2c-490b1071262f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 289417130,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "e697972c-71fa-427a-9f2c-79602f3d69e1",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1120726804,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "f1b39e20-fbc3-4737-8060-1b04866f0f30",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "4261ab2a-8ede-41b7-b1b4-7061291a6784",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "2c79df0a-f585-4b67-a553-f3bddd123b73",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 831309674,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "e73a3076-6e35-445d-aa79-0a3b544dbf30",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1120726804,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "bdae855d-666a-4b27-bd5c-149e76d3e3b8",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Smart & Final",
          initialInvestmentDate: "2019-06-19",
          totalInvestedCapital: {
            id: "4b9eaf6d-aee8-4030-9f76-5d4f06bc1497",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 445000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "201667db-a5c3-4b7a-92a2-4bdefa5873bd",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 445000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "55de4857-5b03-454d-9ff9-d49d93451429",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1010180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6116512b-227d-450e-b00d-23c156545faf",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "4a850257-e873-43fc-9caf-7d7be926c917",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "208d458c-c29c-42da-91b7-1082e3d9f52e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 565180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "770bd411-353a-46b4-bfbb-ee8ece360bd9",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1010180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "d5c2b9f1-f113-427a-a7e7-a5c56852f5a1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Tech Data",
          initialInvestmentDate: "2020-06-30",
          totalInvestedCapital: {
            id: "0420f787-4d63-4ef8-bd26-bfab5de51be4",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1407600000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "41e73773-b377-449f-9da3-ea017f06e8ad",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 1407600000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "6e8750bb-895e-4518-8995-1c7554606b76",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 2970906580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "c715c652-8be2-4764-b6fb-103f36960deb",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "d0fdde6e-ef64-4ed5-9566-7a08d4d91594",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "84633908-564e-4017-8a5f-622a47775258",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1563306580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "5ea7b45e-4b84-4595-8859-5a719987029e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 2970906580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6aae2d8c-c784-41ed-836d-a9778d3eec18",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "DEAL",
          dealType: "Distressed buyout",
          name: "Swissport",
          initialInvestmentDate: "2020-12-21",
          totalInvestedCapital: {
            id: "5a017589-4741-4477-a254-a617af501a7a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 189420404,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "ff5083f2-ce38-4aed-8122-6f80673a5e5f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 189420404,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "1233f307-0661-4f0d-b426-a29557ea78a5",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 417495962,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8e7ff0d4-c3f4-48fa-a2a9-e10e0abd5ea2",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "83497d91-c8a5-48b7-93b4-bda26fd747f5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "baa83131-381d-4e89-90a9-4c453d225b55",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 228075558,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "73cb04d3-3503-421d-a07a-e48cd3b33ce2",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 417495962,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "bdae855d-666a-4b27-bd5c-149e76d3e3b8",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Smart & Final",
          initialInvestmentDate: "2019-06-19",
          totalInvestedCapital: {
            id: "4b9eaf6d-aee8-4030-9f76-5d4f06bc1497",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 445000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "201667db-a5c3-4b7a-92a2-4bdefa5873bd",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 445000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "55de4857-5b03-454d-9ff9-d49d93451429",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1010180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6116512b-227d-450e-b00d-23c156545faf",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "4a850257-e873-43fc-9caf-7d7be926c917",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "208d458c-c29c-42da-91b7-1082e3d9f52e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 565180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "770bd411-353a-46b4-bfbb-ee8ece360bd9",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1010180553,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6aae2d8c-c784-41ed-836d-a9778d3eec18",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "FUND",
          dealType: "Distressed buyout",
          name: "Swissport",
          initialInvestmentDate: "2020-12-21",
          totalInvestedCapital: {
            id: "5a017589-4741-4477-a254-a617af501a7a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 189420404,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "ff5083f2-ce38-4aed-8122-6f80673a5e5f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 189420404,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "1233f307-0661-4f0d-b426-a29557ea78a5",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 417495962,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8e7ff0d4-c3f4-48fa-a2a9-e10e0abd5ea2",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "83497d91-c8a5-48b7-93b4-bda26fd747f5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "baa83131-381d-4e89-90a9-4c453d225b55",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 228075558,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "73cb04d3-3503-421d-a07a-e48cd3b33ce2",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 417495962,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "d5c2b9f1-f113-427a-a7e7-a5c56852f5a1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Tech Data",
          initialInvestmentDate: "2020-06-30",
          totalInvestedCapital: {
            id: "0420f787-4d63-4ef8-bd26-bfab5de51be4",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1407600000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "41e73773-b377-449f-9da3-ea017f06e8ad",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 1407600000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "6e8750bb-895e-4518-8995-1c7554606b76",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 2970906580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "c715c652-8be2-4764-b6fb-103f36960deb",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "d0fdde6e-ef64-4ed5-9566-7a08d4d91594",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "84633908-564e-4017-8a5f-622a47775258",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1563306580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "5ea7b45e-4b84-4595-8859-5a719987029e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 2970906580,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "fa00aa6f-fc0e-42cb-bb13-8e26cdf9f59f",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "FUND",
          dealType: "Distressed buyout",
          name: "Vallourec",
          initialInvestmentDate: "2021-06-30",
          totalInvestedCapital: {
            id: "58721401-0e60-4e93-97d8-1eb5e60de3a2",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 289417130,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "a4511019-f528-456e-9f2c-490b1071262f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 289417130,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "e697972c-71fa-427a-9f2c-79602f3d69e1",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1120726804,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "f1b39e20-fbc3-4737-8060-1b04866f0f30",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "4261ab2a-8ede-41b7-b1b4-7061291a6784",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "2c79df0a-f585-4b67-a553-f3bddd123b73",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 831309674,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "e73a3076-6e35-445d-aa79-0a3b544dbf30",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1120726804,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
      ],
    },
  ],
  unrealized: [
    {
      category: "Distressed Debt",
      holdings: [
        {
          id: "649504ca-b1c5-4135-addf-c15151e38bd3",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Debt Investment",
          currencyType: "DEAL",
          dealType: "Debt Investment",
          name: "Debt Investment",
          initialInvestmentDate: "2018-04-12",
          totalInvestedCapital: {
            id: "91fe4c05-4e25-4b73-9b8a-73f8ebc71f4a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 23390899,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "cfce73f7-1080-4ab9-adfd-8220edc3a1eb",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "74269911-d637-4d35-85a3-687723d9cf16",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 766018541,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "48b26f0b-f4a4-4fa7-b79e-8b452dd6f1a6",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: -23390899,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "682dd479-bdab-4fd3-8004-a7d629e9dfd5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "5670dc1c-2a7e-461f-98c7-f5946d7bd96b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1162067532,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "40d80f3b-a37d-439d-baf6-4abd0cef3527",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1185458431,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "649504ca-b1c5-4135-addf-c15151e38bd3",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Debt Investment",
          currencyType: "FUND",
          dealType: "Debt Investment",
          name: "Debt Investment",
          initialInvestmentDate: "2018-04-12",
          totalInvestedCapital: {
            id: "91fe4c05-4e25-4b73-9b8a-73f8ebc71f4a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 23390899,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "cfce73f7-1080-4ab9-adfd-8220edc3a1eb",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "74269911-d637-4d35-85a3-687723d9cf16",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 766018541,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "48b26f0b-f4a4-4fa7-b79e-8b452dd6f1a6",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: -23390899,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "682dd479-bdab-4fd3-8004-a7d629e9dfd5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "5670dc1c-2a7e-461f-98c7-f5946d7bd96b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1162067532,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "40d80f3b-a37d-439d-baf6-4abd0cef3527",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1185458431,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
      ],
    },
    {
      category: "Private Buyout",
      holdings: [
        {
          id: "426d169a-0e16-4bef-b32d-62823b7f8cd2",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "Celeros Flow Technology",
          initialInvestmentDate: "2020-03-30",
          totalInvestedCapital: {
            id: "06e093d1-5038-436b-acae-3e2ff1bc926f",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 86930114,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "f2b83591-1046-4fec-ab77-5fb6f2e8d0cd",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 2487790,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "cea0a6b1-4f33-4153-849c-231c5546c3b1",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 17894777,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "a4fdb1a2-bf24-4780-8f0b-16ae1bb48297",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "15a5455d-0f7d-44c1-9e9e-261f4a8c54df",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 84442324,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "6c162860-5bee-4c7d-84a3-ebc0999f3cc3",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 130309832,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "b36f4b04-1ecd-48d0-81aa-4982e0bd9692",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 132797621,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "823ed29a-0a3e-4719-8a00-b616f499f231",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "Brightspeed",
          initialInvestmentDate: "2022-10-03",
          totalInvestedCapital: {
            id: "723fd7a9-dc8c-44e5-8de2-2e98a17bb0ae",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1546334332,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "0a671f06-2f69-4abf-b405-ae09a08ab0a5",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b10392af-25a5-4f8d-8e91-6905e55f1be4",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "27748464-009c-431a-ba4e-2a8d73436416",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "bc4a0592-44c0-4002-af91-b1f8a5cfc917",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1546334332,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "a5345743-1dae-44e2-aaac-17bb6c17d1c1",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 892181496,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "66a44445-239a-4070-8bab-8b29bb1f24b5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 892181496,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "8802ebe0-8ad5-4530-ac68-87a1770bbe87",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Novolex",
          initialInvestmentDate: "2022-04-13",
          totalInvestedCapital: {
            id: "5741b285-be3e-4ffe-937f-a882ee858671",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1265879108,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "1b26d165-b957-4507-88d3-0cac345d2a14",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 77590092,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "cb5d480d-f54b-424e-b639-d389a61101fc",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 209313131,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e7180b92-08d8-4723-b6b5-155278c00fee",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0726ab0f-10d8-4a9d-8224-1990d7a059a7",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1188289016,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "e07ba469-45cf-4896-9fc5-117bd3fda7a4",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1761021306,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "b7cd5827-c104-4877-82af-0784c1f72044",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1838611398,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "886a3471-4ffb-4912-acda-c841d9d75f2a",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Legendary Pictures",
          initialInvestmentDate: "2022-01-31",
          totalInvestedCapital: {
            id: "0e61c076-1afd-42e5-9f94-ca0dc1e9aac0",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "2e518394-12e8-4a98-be32-0ac42db19c2e",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "385584af-01a3-4606-a4ba-172601095d1a",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "38d337e7-ebb9-4154-8b0d-3ad7dc85b61d",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          workingCapital: {
            id: "4b89671e-48d8-4b5e-8fa1-2136660607e5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "b7169d59-7985-45fd-8f43-46e73755b2a5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "6603c774-b995-41e0-9def-2fd236328a5e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
        },
        {
          id: "2ee39159-04c8-40c1-8b37-00641dc4f2e3",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "The Michaels Companies",
          initialInvestmentDate: "2021-04-15",
          totalInvestedCapital: {
            id: "2ada89d6-285b-4208-acaf-df08ac6384bc",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1053751331,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          returnOfCapital: {
            id: "833a1ed5-b76e-4d8a-b533-62520f1bf50b",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "cdb76f73-f40d-45de-9a94-707e5f828b1f",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e80b25db-fa60-4c43-93c9-1816e34cf455",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          workingCapital: {
            id: "8c6c0d05-5b55-4b4a-b271-901671a7aa25",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1053751331,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "b6c9bd73-7ee0-4dcc-8890-c205c7f1be4c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 861111566,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "362d73b5-311a-42fa-892e-d61598c3e413",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 861111566,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2023-09-30T00:00:00",
          },
        },
        {
          id: "ec7b13a2-d118-49b1-9a2e-038dea49d655",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "MAFTEC",
          initialInvestmentDate: "2022-03-01",
          totalInvestedCapital: {
            id: "bb280134-128d-4063-a435-aa699034f592",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 162000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "026c1802-3d07-4384-8d51-dfdcbce00440",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 46659746,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "2f448258-9c4e-413c-a3de-d41b64803ca2",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 96076745,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6a33eb73-4927-4fe6-968f-e8cad02c05c7",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "408cff9b-bf07-4792-beeb-1b47197c23c5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 115340254,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "c167db2a-5672-4d49-8305-6f6330e2fecb",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 252258323,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8ba1fe61-9239-41f4-afdf-dc52ec29699b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 298918069,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "2c46b4db-0d6a-42b8-a76a-c030e8a9c6db",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Lottomatica",
          initialInvestmentDate: "2019-11-12",
          totalInvestedCapital: {
            id: "78256084-529e-4686-93bc-07d79cae3700",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 392185347,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "5fc7bc0a-807e-4f72-a2ea-679d82bc826e",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 392185347,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "82dbce86-0d4d-44bd-a86f-6ca8560d6fad",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1665428478,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6d8fd18a-b6fe-4154-b077-75d7a3907a3e",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "3103b6b4-4de9-445d-b4f0-cc139b1af1c0",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "6850d029-5efa-41f5-9da1-8f60797deae7",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 2247485543,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "3133bd31-8282-455a-8117-135cd5ecb564",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 2639670890,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "9398c290-53f7-42d1-ab7e-c3b2d3ed66c1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "New Home",
          initialInvestmentDate: "2021-09-08",
          totalInvestedCapital: {
            id: "3499050c-4545-40b1-8bd1-3b5a8159cf2c",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 247500000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "48cc5538-1817-4f28-8c1c-82f5cbde2ba5",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "39ee9b87-c5ca-4207-b283-9f3835d2094d",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6c445e7f-e880-4c61-929b-c43614a09653",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "87b14739-c15c-4a5c-810a-71fcd7d2a8fe",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 247500000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "12831112-0c95-49ea-a8a9-40231801f54c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 572465605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "f0564a56-df70-4c3e-8dd1-674ede287559",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 572465605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "a2446e4a-426c-4af7-8585-5caed4b754a1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Covis Pharma",
          initialInvestmentDate: "2020-03-10",
          totalInvestedCapital: {
            id: "abe534e9-c872-4dda-999a-d08549ff21fa",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 512726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "18bc41b1-96e6-447c-824e-9dd0582adb51",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "17984760-1bc6-4755-90f0-591e6ee697dd",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "5b26ee52-a2d1-4c0d-a1a8-e683043ffbf0",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: -507726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "5af70f47-8ed2-4138-aba8-7d96431cb0bc",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 5000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "de56bc68-7bcc-400a-9bee-87deef504d66",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: -502726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "e1f1d7b9-5b62-4207-ad18-4d413437e1ea",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 5000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "1b1cab2c-f94b-4079-a195-3560ffef244e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "Cox Media Group",
          initialInvestmentDate: "2019-12-17",
          totalInvestedCapital: {
            id: "15d9041e-4df8-4968-90e1-32eca0f1fd33",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 810955853,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "6241adbc-cb86-462e-9a8e-01e2ff58625c",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 267227046,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ffa42f50-1ff5-493f-88ef-d3978f7b5299",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 661413818,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "1e23dcd8-2250-49a0-9eff-7e93e6a7f583",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "d8fe0b99-eec7-4393-8b3c-9d9fa5424935",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 543728807,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "67d89f6a-28b7-4a9c-8f3e-ee2da168756e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 991386007,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "7499ce68-5313-48a0-90cf-4976f1bd72fe",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1258613053,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "22182e3f-4a22-49d7-9bd2-ef6a735050df",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "DEAL",
          dealType: "Distressed buyout",
          name: "Aeromexico",
          initialInvestmentDate: "2022-03-30",
          totalInvestedCapital: {
            id: "58598268-d584-41d7-83fa-9cd6490bd63b",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 243481163,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "074a2da9-2baa-4c9a-ae36-315fe1e919b1",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 48810868,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ea2f0516-1938-4889-b7f5-3cd957f52297",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 242035438,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8329ff59-64c5-4539-a4aa-a356b265bda9",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "17a73674-3b91-4910-9e53-1ffeccb5d156",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 194670295,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4674f62d-b578-43cd-8197-3c49b648175a",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 597298084,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "058d9a3f-e4c2-45c7-b604-2503a8236e67",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 646108952,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "b722ddf6-67e8-459b-9394-85656dae5d9c",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "Ingenico TSS",
          initialInvestmentDate: "2022-09-23",
          totalInvestedCapital: {
            id: "b50504af-fe9b-426e-8ea0-137c6f0455bd",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 393431542,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "18e80129-0d62-4813-9b40-63995b73e96f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 99860166,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ede77a76-d740-455a-b595-81c312b33f7e",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 169136901,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "ce458003-e6f1-4bfb-9586-852a676177ce",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "b731d8fb-d529-4065-9fa6-07087152e7bd",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 293571376,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "43143ec1-8f80-447d-b732-7f34890f9b43",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 302122958,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8697906a-15f5-432b-a492-8b4be090c5b4",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 401983124,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "34589b64-e7eb-4ecd-a3e2-c9eace436a7e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "MCP Holdings (PetSmart)",
          initialInvestmentDate: "2023-10-01",
          totalInvestedCapital: {
            id: "3d4d2cb6-6a81-4c9b-a48f-ccdd25e449de",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 737729370,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "b635220c-a835-4cb7-8455-5be011ed827f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "bc435747-ceb4-4746-95ac-0a2d613c385c",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e0d525f3-5b38-45af-abbe-04e54dd4d408",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "c6e06de2-f0f2-498c-9305-953ec501b034",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 737729370,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d08c7c6c-6f75-4fce-a097-e06446eee12d",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 762716429,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "09a1f4f6-b643-40a3-9176-a5bb1f82646f",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 762716429,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "ce96ae20-27da-41e7-b26f-71bfd1c0064a",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Heritage Grocers Group",
          initialInvestmentDate: "2022-04-20",
          totalInvestedCapital: {
            id: "30c71e2e-fb6f-4bee-877f-2819382271b9",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 369274879,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "05800274-ab68-4614-8db6-95df95353535",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "fb177cbc-44d2-45db-8024-82725ee49664",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "0fd5f5e6-e37c-4bfe-9bcd-51948f13bcd1",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "e37868f8-d14c-44cf-b8c1-6e1738cef890",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 369274879,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "8ecc9f0c-6de6-45ef-9e6a-3fa9a71b92cf",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 366767897,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "39f85aca-2875-4267-adf6-9eaec60e2393",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 366767897,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "d7da9c97-61a8-448e-be7b-1d86fd1f935e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "The Venetian",
          initialInvestmentDate: "2022-02-23",
          totalInvestedCapital: {
            id: "86ccebc6-7548-45af-bd65-6cdae4dcf2f5",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1045000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "b5eccf9d-8b54-4019-903a-471643500c41",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 210541784,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "997a7325-6e0c-4b08-837e-4b90aa59af86",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 951815882,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "a800fbc1-b9b5-47ba-89ad-94f7a8416d1f",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "b779cc57-ba62-450c-ba1c-0a3d5e09195b",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 834458216,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "82ab8342-063f-432f-a108-8cbf380441ff",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 3089469311,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8dd80d54-77b6-4784-a507-cef87b5f259b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 3300011095,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "06e4e9d3-7be4-42e9-8487-a07ab11b3056",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Venture Capital",
          currencyType: "FUND",
          dealType: "Venture Capital",
          name: "25Madison",
          initialInvestmentDate: "2020-12-15",
          totalInvestedCapital: {
            id: "e12ca52c-e5df-42be-afba-5a3e478879c2",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "460bcce1-1298-4a09-a640-27cf075dff87",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "c1066196-07e7-4748-8bb2-94750c2630c5",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "c75b908e-c6bd-4ea5-b9fb-362e6a376b5b",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "86276fee-5750-407d-9e84-30a93383dbf1",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "9e859c56-db3d-4c99-97c3-8ec06f2ee7aa",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "4e27676c-13fb-472f-918f-8c53c41f7e32",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "ec7b13a2-d118-49b1-9a2e-038dea49d655",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "MAFTEC",
          initialInvestmentDate: "2022-03-01",
          totalInvestedCapital: {
            id: "bb280134-128d-4063-a435-aa699034f592",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 162000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "026c1802-3d07-4384-8d51-dfdcbce00440",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 46659746,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "2f448258-9c4e-413c-a3de-d41b64803ca2",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 96076745,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6a33eb73-4927-4fe6-968f-e8cad02c05c7",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "408cff9b-bf07-4792-beeb-1b47197c23c5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 115340254,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "c167db2a-5672-4d49-8305-6f6330e2fecb",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 252258323,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8ba1fe61-9239-41f4-afdf-dc52ec29699b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 298918069,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6ea39e06-4c2c-41ea-bd0f-a0f3ee3fb106",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Aspen Insurance",
          initialInvestmentDate: "2019-02-15",
          totalInvestedCapital: {
            id: "681040f9-bf97-44c9-a60b-c85f7940009d",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1635517106,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "76be0a4d-8f43-47a6-9d2d-2612a17fe52e",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 93096075,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "09b547ec-3b16-4696-b0a4-0828ef6d7efc",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 185489296,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "b2fefb43-376c-4676-a2b0-e6d568e4dbea",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "66e99203-5ccf-40e9-a3c3-c146f31fb52d",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1542421031,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "90bf7202-b88f-4435-a07a-db159c2369a1",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1425104960,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "4e262d3f-19f7-4189-af6d-743a3382bd8c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1518201035,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "9398c290-53f7-42d1-ab7e-c3b2d3ed66c1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "New Home",
          initialInvestmentDate: "2021-09-08",
          totalInvestedCapital: {
            id: "3499050c-4545-40b1-8bd1-3b5a8159cf2c",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 247500000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "48cc5538-1817-4f28-8c1c-82f5cbde2ba5",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "39ee9b87-c5ca-4207-b283-9f3835d2094d",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "6c445e7f-e880-4c61-929b-c43614a09653",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "87b14739-c15c-4a5c-810a-71fcd7d2a8fe",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 247500000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "12831112-0c95-49ea-a8a9-40231801f54c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 572465605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "f0564a56-df70-4c3e-8dd1-674ede287559",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 572465605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "103cc193-65d8-4b34-855a-c2fadb4504dc",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Shutterfly",
          initialInvestmentDate: "2019-09-25",
          totalInvestedCapital: {
            id: "df5d432e-be8d-4e64-9722-4066cac505bb",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 722654743,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "6957ce06-3548-48d3-9123-9c5ade424588",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "8be24a42-817c-4676-b490-406e7c6d178e",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "d2df1ec6-4b89-49bc-b336-40df0dc53620",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "a5d7ff85-d96d-463c-8fb0-f17ce7b74864",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 722654743,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4fb797de-4201-42c3-a4d2-0910f77eadbd",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1255742593,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "9f6767b4-b696-4035-8868-a731e513a071",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1255742593,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6e7c1644-b265-4ad3-a536-3488bc6a6f7f",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Showa Aluminum",
          initialInvestmentDate: "2021-06-24",
          totalInvestedCapital: {
            id: "cd38c40c-8fcb-4eff-9ed5-98bc9cabbcf7",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 227000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          returnOfCapital: {
            id: "af4b8d3f-e3ed-4301-b942-92b14122f7c7",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "1e85c28c-4f7a-4873-9b34-76d292405d8c",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e6682e6c-6765-46e2-b01c-b6163e33972d",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          workingCapital: {
            id: "a11f4cd9-709e-4b6c-b115-b02421faf413",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 227000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4eb370c6-2700-4025-b05b-80f033053513",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 307762283,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "aee58913-0a9c-4e25-898f-bdf5026df00b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 307762283,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-03-31T00:00:00",
          },
        },
        {
          id: "80fb1a86-65cc-45f5-85b4-d8485b67bc10",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Great Canadian Gaming",
          initialInvestmentDate: "2021-09-22",
          totalInvestedCapital: {
            id: "2f14a7d7-a3c6-41e4-a6ce-e00fd365318f",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 914799057,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "20875976-c5de-45fa-9752-0f351f5b1369",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 327942832,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "f1f03aed-03dd-4730-8c85-7a271ca5903b",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 815940467,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "938b2d8d-217d-4a70-b31c-b799eae0975f",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "20a24bc8-e4f2-4646-9e23-3d631934648e",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 586856225,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "6f7a0a7a-e97d-47e6-bb97-bd8836025f5e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1427478236,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "5b201469-8a74-46cd-b91c-fd0b725c0177",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1755421069,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "a2446e4a-426c-4af7-8585-5caed4b754a1",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Covis Pharma",
          initialInvestmentDate: "2020-03-10",
          totalInvestedCapital: {
            id: "abe534e9-c872-4dda-999a-d08549ff21fa",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 512726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "18bc41b1-96e6-447c-824e-9dd0582adb51",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "17984760-1bc6-4755-90f0-591e6ee697dd",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "5b26ee52-a2d1-4c0d-a1a8-e683043ffbf0",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: -507726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "5af70f47-8ed2-4138-aba8-7d96431cb0bc",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 5000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "de56bc68-7bcc-400a-9bee-87deef504d66",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: -502726008,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "e1f1d7b9-5b62-4207-ad18-4d413437e1ea",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 5000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "c20e9a1a-3cb8-48a6-881e-a63ee423f377",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "DEAL",
          dealType: "Distressed buyout",
          name: "ABC Technologies",
          initialInvestmentDate: "2021-06-24",
          totalInvestedCapital: {
            id: "8d3a6c96-925d-493e-b723-1bd974cb072a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 455058820,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "95e1906e-1276-4147-8bb9-3d619a52df74",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "f1c7ae29-23b5-4322-906b-8701d5bb3f51",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1616409,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "3c494a89-addd-48bc-8da0-c1dbaa301e07",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "8249417d-e51d-4a6e-bb09-bc7cdcc1c4b3",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 455058820,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d9186c99-56b5-4ed7-a371-43f0c81a93d0",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 457605766,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "3ce8bf2b-e817-40eb-bd0c-a2c4ba3f9773",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 457605766,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "70cf733c-975c-4f87-ab9b-c9b4907f5cd2",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "MCP Holdings (Michaels)",
          initialInvestmentDate: "2021-04-15",
          totalInvestedCapital: {
            id: "f5d6d10a-0822-45d0-9ce9-1808e4c324d9",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1053751331,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "6ebeaf6d-d929-4c02-b2b8-1989b47f5d12",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ff989b94-45a3-4390-8568-894c1fa45350",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "c114b96b-9c4c-4141-9f91-422350e9e2a5",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "e45c1904-f494-4d11-b8b2-838c4ff329ed",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1053751331,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "16deb788-be1f-4de2-a313-b8a788f58944",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 521426361,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "7cf4d87d-e16d-40eb-a3c8-a4b2307fde74",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 521426361,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "fa8cd53e-2d1e-4393-bd51-be8c2edc9298",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "LifePoint Health",
          initialInvestmentDate: "2021-06-25",
          totalInvestedCapital: {
            id: "ddaf63ed-33de-4983-b4c9-3da591238eca",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1975000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          returnOfCapital: {
            id: "cf0f44f0-fc43-42ea-afbe-07f3b99ea5f1",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "90749e32-48b4-4079-8873-340189e75775",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "641cf2f1-7d72-409d-a29f-189d2184b41b",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          workingCapital: {
            id: "25eed283-9e1f-4773-b2d7-40a3234f00b5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1975000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "a2e905ab-4c48-4d45-ba7b-7c82c4f96d46",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 2125054999,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "76078a9b-dc42-47ca-8e90-866cff8b722c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 2125054999,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-09-30T00:00:00",
          },
        },
        {
          id: "a64e5ecb-36fe-423c-a3c2-3e154c707e98",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Tenneco",
          initialInvestmentDate: "2022-11-17",
          totalInvestedCapital: {
            id: "c3dbc8d1-203f-4591-8511-ad37c736c6ed",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1398577291,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "fa64e17e-0dec-4e65-b7a4-b2b37e4c23af",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "405c11fa-c000-4851-9b6f-489296d0594c",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1549716,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "1f9a021c-f3f4-47de-af8b-b3a9da5b4bdb",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "260635b9-e1c8-471a-babf-3293f2f837bd",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1398577291,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "60bc471e-d8e2-4ba6-b678-54af172e1cb3",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 3016578815,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "fa5e9710-d387-49d6-9cb2-27063f488716",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 3016578815,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "c20e9a1a-3cb8-48a6-881e-a63ee423f377",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "FUND",
          dealType: "Distressed buyout",
          name: "ABC Technologies",
          initialInvestmentDate: "2021-06-24",
          totalInvestedCapital: {
            id: "8d3a6c96-925d-493e-b723-1bd974cb072a",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 455058820,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "95e1906e-1276-4147-8bb9-3d619a52df74",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "f1c7ae29-23b5-4322-906b-8701d5bb3f51",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1616409,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "3c494a89-addd-48bc-8da0-c1dbaa301e07",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "8249417d-e51d-4a6e-bb09-bc7cdcc1c4b3",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 455058820,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d9186c99-56b5-4ed7-a371-43f0c81a93d0",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 457605766,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "3ce8bf2b-e817-40eb-bd0c-a2c4ba3f9773",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 457605766,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6ea39e06-4c2c-41ea-bd0f-a0f3ee3fb106",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Aspen Insurance",
          initialInvestmentDate: "2019-02-15",
          totalInvestedCapital: {
            id: "681040f9-bf97-44c9-a60b-c85f7940009d",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1635517106,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "76be0a4d-8f43-47a6-9d2d-2612a17fe52e",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 93096075,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "09b547ec-3b16-4696-b0a4-0828ef6d7efc",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 185489296,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "b2fefb43-376c-4676-a2b0-e6d568e4dbea",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "66e99203-5ccf-40e9-a3c3-c146f31fb52d",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1542421031,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "90bf7202-b88f-4435-a07a-db159c2369a1",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1425104960,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "4e262d3f-19f7-4189-af6d-743a3382bd8c",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1518201035,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "22182e3f-4a22-49d7-9bd2-ef6a735050df",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Distressed buyout",
          currencyType: "FUND",
          dealType: "Distressed buyout",
          name: "Aeromexico",
          initialInvestmentDate: "2022-03-30",
          totalInvestedCapital: {
            id: "58598268-d584-41d7-83fa-9cd6490bd63b",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 243481163,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "074a2da9-2baa-4c9a-ae36-315fe1e919b1",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 48810868,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ea2f0516-1938-4889-b7f5-3cd957f52297",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 242035438,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8329ff59-64c5-4539-a4aa-a356b265bda9",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "17a73674-3b91-4910-9e53-1ffeccb5d156",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 194670295,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4674f62d-b578-43cd-8197-3c49b648175a",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 597298084,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "058d9a3f-e4c2-45c7-b604-2503a8236e67",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 646108952,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "b003142b-e357-4b4b-8021-6194b0b34443",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Altemira",
          initialInvestmentDate: "2021-06-24",
          totalInvestedCapital: {
            id: "725df581-23b7-4226-97c1-6d4a727d7372",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 227000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "56571cb5-7561-4c2d-bff7-eaaf103993d5",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 56180557,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "f8ceed2a-42c4-4091-be37-726987789e6e",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 175850063,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "094f4d58-a7e5-4a6d-a0f3-01334c055d4c",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "f0cfd410-e052-4634-9ea3-56fcfd520d24",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 170819443,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "ee3a2d5c-349f-4a87-b4f2-8ac3a6bb5f8f",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 502202829,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "a0afe4ba-41ca-415a-98e0-652a086bf746",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 558383386,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "d780dc1e-fd80-4b76-9d15-0e569f0566da",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Kem One",
          initialInvestmentDate: "2021-12-17",
          totalInvestedCapital: {
            id: "10273fdc-03e3-46c4-ad88-9d3f80823f7d",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 247708500,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "3b225655-00e1-4e24-be42-d2e30e32edae",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 46945000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "31932ea8-95c9-4179-97e4-ea4824920b45",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 46945000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "30b9b68f-bd9a-489c-84bf-0ad774fa7d0b",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0afbaf7f-eadb-49ac-9aaf-c54b5978947b",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 200763500,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "a96a4b79-1025-41fb-81df-7dcc3ab3cf47",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 339745471,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "dfc25a41-6fef-409e-828b-39ee87d146b7",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 386690471,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "80fb1a86-65cc-45f5-85b4-d8485b67bc10",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Great Canadian Gaming",
          initialInvestmentDate: "2021-09-22",
          totalInvestedCapital: {
            id: "2f14a7d7-a3c6-41e4-a6ce-e00fd365318f",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 914799057,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "20875976-c5de-45fa-9752-0f351f5b1369",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 327942832,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "f1f03aed-03dd-4730-8c85-7a271ca5903b",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 815940467,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "938b2d8d-217d-4a70-b31c-b799eae0975f",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "20a24bc8-e4f2-4646-9e23-3d631934648e",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 586856225,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "6f7a0a7a-e97d-47e6-bb97-bd8836025f5e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1427478236,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "5b201469-8a74-46cd-b91c-fd0b725c0177",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1755421069,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "426d169a-0e16-4bef-b32d-62823b7f8cd2",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Celeros Flow Technology",
          initialInvestmentDate: "2020-03-30",
          totalInvestedCapital: {
            id: "06e093d1-5038-436b-acae-3e2ff1bc926f",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 86930114,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "f2b83591-1046-4fec-ab77-5fb6f2e8d0cd",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 2487790,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "cea0a6b1-4f33-4153-849c-231c5546c3b1",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 17894777,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "a4fdb1a2-bf24-4780-8f0b-16ae1bb48297",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "15a5455d-0f7d-44c1-9e9e-261f4a8c54df",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 84442324,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "6c162860-5bee-4c7d-84a3-ebc0999f3cc3",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 130309832,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "b36f4b04-1ecd-48d0-81aa-4982e0bd9692",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 132797621,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "ce144369-949a-4290-9aff-535da235c22e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "EmployBridge",
          initialInvestmentDate: "2021-07-19",
          totalInvestedCapital: {
            id: "844255a3-8134-4b46-a0c4-a37eb1919698",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 525000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "84a52e28-27e3-4571-9f66-37bd97fd4a64",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "6970f1b4-5aae-499d-88c2-bb4b4c69cc7d",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8b669e94-0be4-4705-a458-7e93b659c5ec",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "6453b159-d3b2-49fe-8e85-e85e9b74fee7",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 525000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4172ec8a-4b11-45bd-a31a-ed95756528ac",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 663842795,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "a0e35100-b93e-4a0f-b4b2-43b42d90a84a",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 663842795,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "34589b64-e7eb-4ecd-a3e2-c9eace436a7e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "MCP Holdings (PetSmart)",
          initialInvestmentDate: "2023-10-01",
          totalInvestedCapital: {
            id: "3d4d2cb6-6a81-4c9b-a48f-ccdd25e449de",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 737729370,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "b635220c-a835-4cb7-8455-5be011ed827f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "bc435747-ceb4-4746-95ac-0a2d613c385c",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e0d525f3-5b38-45af-abbe-04e54dd4d408",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "c6e06de2-f0f2-498c-9305-953ec501b034",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 737729370,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d08c7c6c-6f75-4fce-a097-e06446eee12d",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 762716429,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "09a1f4f6-b643-40a3-9176-a5bb1f82646f",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 762716429,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6e4f91f3-1764-469a-af86-0161746a8de4",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Miller Homes",
          initialInvestmentDate: "2022-03-31",
          totalInvestedCapital: {
            id: "b10c269d-0607-4fab-8ab1-744154159fe5",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 419099162,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "5a6187ba-cb44-4d56-adf9-663c2040d4bc",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 93205880,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b3087a12-eb8e-4a9c-996f-6f207017fe2f",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 93205880,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "0892cda4-ed5c-4782-bebc-a900cd2ab72c",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0fb255c2-589c-427b-8d00-e1082be918af",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 325893282,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d219c232-ab19-4b48-875c-8fa06ae7f422",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 438685725,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "f011e6ea-6048-427b-9bf1-086d39fe335d",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 531891605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "b722ddf6-67e8-459b-9394-85656dae5d9c",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Ingenico TSS",
          initialInvestmentDate: "2022-09-23",
          totalInvestedCapital: {
            id: "b50504af-fe9b-426e-8ea0-137c6f0455bd",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 393431542,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "18e80129-0d62-4813-9b40-63995b73e96f",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 99860166,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ede77a76-d740-455a-b595-81c312b33f7e",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 169136901,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "ce458003-e6f1-4bfb-9586-852a676177ce",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "b731d8fb-d529-4065-9fa6-07087152e7bd",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 293571376,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "43143ec1-8f80-447d-b732-7f34890f9b43",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 302122958,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8697906a-15f5-432b-a492-8b4be090c5b4",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 401983124,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "fd230b62-90ee-4f21-a079-224b9ff17cfa",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "Yahoo",
          initialInvestmentDate: "2021-09-01",
          totalInvestedCapital: {
            id: "4a03aa51-efc6-4caa-9a9c-18b064feddb9",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1750000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "0a81ca79-138f-4a66-9b63-ddaf4b69bb54",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 845830950,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b11e6baf-8b19-441c-8b2a-1d25ade9a43f",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1505581215,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "f1d19dfc-332b-4c7f-b2f3-c8a21d0a74a3",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "7604f293-d601-4cae-bc45-ae2ebea3b85c",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 904169050,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "abbf3dc9-0ecc-48e4-9fca-20374cc406e5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 4388558979,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "d552043c-2b44-4cb2-b2dc-35689bf75f40",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 5234389929,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "823ed29a-0a3e-4719-8a00-b616f499f231",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Brightspeed",
          initialInvestmentDate: "2022-10-03",
          totalInvestedCapital: {
            id: "723fd7a9-dc8c-44e5-8de2-2e98a17bb0ae",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1546334332,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "0a671f06-2f69-4abf-b405-ae09a08ab0a5",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b10392af-25a5-4f8d-8e91-6905e55f1be4",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "27748464-009c-431a-ba4e-2a8d73436416",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "bc4a0592-44c0-4002-af91-b1f8a5cfc917",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1546334332,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "a5345743-1dae-44e2-aaac-17bb6c17d1c1",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 892181496,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "66a44445-239a-4070-8bab-8b29bb1f24b5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 892181496,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "ce144369-949a-4290-9aff-535da235c22e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "EmployBridge",
          initialInvestmentDate: "2021-07-19",
          totalInvestedCapital: {
            id: "844255a3-8134-4b46-a0c4-a37eb1919698",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 525000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "84a52e28-27e3-4571-9f66-37bd97fd4a64",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "6970f1b4-5aae-499d-88c2-bb4b4c69cc7d",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8b669e94-0be4-4705-a458-7e93b659c5ec",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "6453b159-d3b2-49fe-8e85-e85e9b74fee7",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 525000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4172ec8a-4b11-45bd-a31a-ed95756528ac",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 663842795,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "a0e35100-b93e-4a0f-b4b2-43b42d90a84a",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 663842795,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "1b1cab2c-f94b-4079-a195-3560ffef244e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Cox Media Group",
          initialInvestmentDate: "2019-12-17",
          totalInvestedCapital: {
            id: "15d9041e-4df8-4968-90e1-32eca0f1fd33",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 810955853,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "6241adbc-cb86-462e-9a8e-01e2ff58625c",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 267227046,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "ffa42f50-1ff5-493f-88ef-d3978f7b5299",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 661413818,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "1e23dcd8-2250-49a0-9eff-7e93e6a7f583",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "d8fe0b99-eec7-4393-8b3c-9d9fa5424935",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 543728807,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "67d89f6a-28b7-4a9c-8f3e-ee2da168756e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 991386007,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "7499ce68-5313-48a0-90cf-4976f1bd72fe",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1258613053,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6f5f4e1b-036a-4234-9e74-16aba70c8956",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Tonys Fresh Market",
          initialInvestmentDate: "2022-04-20",
          totalInvestedCapital: {
            id: "315ca22e-81a0-4ce0-9a64-d474a944b537",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 81000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          returnOfCapital: {
            id: "a5b1649e-a0c6-4a44-9d0d-743666aa0df8",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b386e8b1-9e94-4bf5-aa37-61277963fdfe",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "74ddf801-1590-4b0e-86ee-f18d7b79c611",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          workingCapital: {
            id: "bb522d29-803c-4283-aa95-acab44674f12",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 81000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "84c24a0f-73a5-4407-a860-ad4cf53a0435",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 81000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "0fb98cbe-e5d8-4458-9177-8bbc303ac7fc",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 81000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2022-06-30T00:00:00",
          },
        },
        {
          id: "886a3471-4ffb-4912-acda-c841d9d75f2a",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Legendary Pictures",
          initialInvestmentDate: "2022-01-31",
          totalInvestedCapital: {
            id: "0e61c076-1afd-42e5-9f94-ca0dc1e9aac0",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "2e518394-12e8-4a98-be32-0ac42db19c2e",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "385584af-01a3-4606-a4ba-172601095d1a",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "38d337e7-ebb9-4154-8b0d-3ad7dc85b61d",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          workingCapital: {
            id: "4b89671e-48d8-4b5e-8fa1-2136660607e5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "b7169d59-7985-45fd-8f43-46e73755b2a5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "6603c774-b995-41e0-9def-2fd236328a5e",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-12-31T00:00:00",
          },
        },
        {
          id: "d780dc1e-fd80-4b76-9d15-0e569f0566da",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Kem One",
          initialInvestmentDate: "2021-12-17",
          totalInvestedCapital: {
            id: "10273fdc-03e3-46c4-ad88-9d3f80823f7d",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 247708500,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "3b225655-00e1-4e24-be42-d2e30e32edae",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 46945000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "31932ea8-95c9-4179-97e4-ea4824920b45",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 46945000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "30b9b68f-bd9a-489c-84bf-0ad774fa7d0b",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0afbaf7f-eadb-49ac-9aaf-c54b5978947b",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 200763500,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "a96a4b79-1025-41fb-81df-7dcc3ab3cf47",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 339745471,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "dfc25a41-6fef-409e-828b-39ee87d146b7",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 386690471,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "f97360f5-b731-44d6-b30a-5af5ec0339a3",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Gamenet",
          initialInvestmentDate: "2019-11-12",
          totalInvestedCapital: {
            id: "7aeb4787-2012-4d97-9e32-71e0e2740a42",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 195903525,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          returnOfCapital: {
            id: "f00268c5-660c-482b-8333-76e21b765f45",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 5935000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "caa8822c-7eff-49df-8f7d-8d1dfb47f702",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 7796539,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "8931feb4-3630-45d6-aa47-225228ea1a64",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          workingCapital: {
            id: "1e6f43ec-c8d9-44f0-966e-f3c38f1e3d39",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 189968525,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "2116e291-f3f0-4809-bc1e-ff9555f36447",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 286317833,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "3ee497fb-df1e-49f3-8836-097f5152b80a",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 292252833,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2021-03-31T00:00:00",
          },
        },
        {
          id: "a64e5ecb-36fe-423c-a3c2-3e154c707e98",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Tenneco",
          initialInvestmentDate: "2022-11-17",
          totalInvestedCapital: {
            id: "c3dbc8d1-203f-4591-8511-ad37c736c6ed",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1398577291,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "fa64e17e-0dec-4e65-b7a4-b2b37e4c23af",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "405c11fa-c000-4851-9b6f-489296d0594c",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1549716,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "1f9a021c-f3f4-47de-af8b-b3a9da5b4bdb",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "260635b9-e1c8-471a-babf-3293f2f837bd",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1398577291,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "60bc471e-d8e2-4ba6-b678-54af172e1cb3",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 3016578815,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "fa5e9710-d387-49d6-9cb2-27063f488716",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 3016578815,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "103cc193-65d8-4b34-855a-c2fadb4504dc",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Shutterfly",
          initialInvestmentDate: "2019-09-25",
          totalInvestedCapital: {
            id: "df5d432e-be8d-4e64-9722-4066cac505bb",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 722654743,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "6957ce06-3548-48d3-9123-9c5ade424588",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "8be24a42-817c-4676-b490-406e7c6d178e",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "d2df1ec6-4b89-49bc-b336-40df0dc53620",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "a5d7ff85-d96d-463c-8fb0-f17ce7b74864",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 722654743,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "4fb797de-4201-42c3-a4d2-0910f77eadbd",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1255742593,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "9f6767b4-b696-4035-8868-a731e513a071",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1255742593,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "06e4e9d3-7be4-42e9-8487-a07ab11b3056",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Venture Capital",
          currencyType: "DEAL",
          dealType: "Venture Capital",
          name: "25Madison",
          initialInvestmentDate: "2020-12-15",
          totalInvestedCapital: {
            id: "e12ca52c-e5df-42be-afba-5a3e478879c2",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "460bcce1-1298-4a09-a640-27cf075dff87",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "c1066196-07e7-4748-8bb2-94750c2630c5",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "c75b908e-c6bd-4ea5-b9fb-362e6a376b5b",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "86276fee-5750-407d-9e84-30a93383dbf1",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "9e859c56-db3d-4c99-97c3-8ec06f2ee7aa",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "4e27676c-13fb-472f-918f-8c53c41f7e32",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 60056302,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "6e4f91f3-1764-469a-af86-0161746a8de4",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "Miller Homes",
          initialInvestmentDate: "2022-03-31",
          totalInvestedCapital: {
            id: "b10c269d-0607-4fab-8ab1-744154159fe5",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 419099162,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "5a6187ba-cb44-4d56-adf9-663c2040d4bc",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 93205880,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b3087a12-eb8e-4a9c-996f-6f207017fe2f",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 93205880,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "0892cda4-ed5c-4782-bebc-a900cd2ab72c",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0fb255c2-589c-427b-8d00-e1082be918af",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 325893282,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "d219c232-ab19-4b48-875c-8fa06ae7f422",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 438685725,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "f011e6ea-6048-427b-9bf1-086d39fe335d",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 531891605,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "d7da9c97-61a8-448e-be7b-1d86fd1f935e",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "DEAL",
          dealType: "Corporate Carve-Out",
          name: "The Venetian",
          initialInvestmentDate: "2022-02-23",
          totalInvestedCapital: {
            id: "86ccebc6-7548-45af-bd65-6cdae4dcf2f5",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1045000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "b5eccf9d-8b54-4019-903a-471643500c41",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 210541784,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "997a7325-6e0c-4b08-837e-4b90aa59af86",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 951815882,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "a800fbc1-b9b5-47ba-89ad-94f7a8416d1f",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "b779cc57-ba62-450c-ba1c-0a3d5e09195b",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 834458216,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "82ab8342-063f-432f-a108-8cbf380441ff",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 3089469311,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "8dd80d54-77b6-4784-a507-cef87b5f259b",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 3300011095,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "8802ebe0-8ad5-4530-ac68-87a1770bbe87",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "DEAL",
          dealType: "Opportunistic Buyout",
          name: "Novolex",
          initialInvestmentDate: "2022-04-13",
          totalInvestedCapital: {
            id: "5741b285-be3e-4ffe-937f-a882ee858671",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1265879108,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "1b26d165-b957-4507-88d3-0cac345d2a14",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 77590092,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "cb5d480d-f54b-424e-b639-d389a61101fc",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 209313131,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "e7180b92-08d8-4723-b6b5-155278c00fee",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0726ab0f-10d8-4a9d-8224-1990d7a059a7",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1188289016,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "e07ba469-45cf-4896-9fc5-117bd3fda7a4",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 1761021306,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "b7cd5827-c104-4877-82af-0784c1f72044",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 1838611398,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "fe9d1601-2f5e-4bed-a379-65ef16a88314",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Opportunistic Buyout",
          currencyType: "FUND",
          dealType: "Opportunistic Buyout",
          name: "LifePoint Health / ScionHealth",
          initialInvestmentDate: "2021-06-25",
          totalInvestedCapital: {
            id: "18c41909-e6d7-4ced-a742-1dd4fc6cdb9b",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1975000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "7703f2ad-d502-402e-9976-b06cc2426d58",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 800564488,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "7f7269db-4dcb-4690-bd12-a4a5b0e3ae83",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 800564488,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "f9c6efb1-91b4-4bd2-b039-5ef8bf3d1e09",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "0c0f30dc-30bc-467d-a712-22553da1bde5",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 1174435512,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "31f3b671-7a28-4b44-9640-a9f4fb27c613",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 2756012072,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "cb7537ba-a71f-46c6-8a4f-9f19028e2f45",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 3556576559,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
        {
          id: "fd230b62-90ee-4f21-a079-224b9ff17cfa",
          fundId: "d5501e9d-c0e4-4dc4-b66e-004fb9a2b6b2",
          investmentType: "Corporate Carve-Out",
          currencyType: "FUND",
          dealType: "Corporate Carve-Out",
          name: "Yahoo",
          initialInvestmentDate: "2021-09-01",
          totalInvestedCapital: {
            id: "4a03aa51-efc6-4caa-9a9c-18b064feddb9",
            name: "TOTAL_INVESTED_CAPITAL",
            key: "TOTAL_INVESTED_CAPITAL",
            description: "TOTAL_INVESTED_CAPITAL",
            value: {
              amount: 1750000000,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          returnOfCapital: {
            id: "0a81ca79-138f-4a66-9b63-ddaf4b69bb54",
            name: "RETURN_OF_CAPITAL",
            key: "RETURN_OF_CAPITAL",
            description: "RETURN_OF_CAPITAL",
            value: {
              amount: 845830950,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          realizedGains: undefined,
          totalProceeds: {
            id: "b11e6baf-8b19-441c-8b2a-1d25ade9a43f",
            name: "TOTAL_PROCEEDS",
            key: "TOTAL_PROCEEDS",
            description: "TOTAL_PROCEEDS",
            value: {
              amount: 1505581215,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          impairmentsAndAdjustments: {
            id: "f1d19dfc-332b-4c7f-b2f3-c8a21d0a74a3",
            name: "IMPAIRMENT_ADJUSTMENTS",
            key: "IMPAIRMENT_ADJUSTMENTS",
            description: "IMPAIRMENT_ADJUSTMENTS",
            value: {
              amount: 0,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          workingCapital: {
            id: "7604f293-d601-4cae-bc45-ae2ebea3b85c",
            name: "WORKING_CAPITAL",
            key: "WORKING_CAPITAL",
            description: "WORKING_CAPITAL",
            value: {
              amount: 904169050,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValue: undefined,
          remainingValuePlusRealizedGains: {
            id: "abbf3dc9-0ecc-48e4-9fca-20374cc406e5",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_REALIZED",
            value: {
              amount: 4388558979,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
          remainingValuePlusTotalProceeds: {
            id: "d552043c-2b44-4cb2-b2dc-35689bf75f40",
            name: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            key: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            description: "ESTIMATED_REMAINING_VALUE_PLUS_PROCEEDS",
            value: {
              amount: 5234389929,
              currency: "USD",
            },
            createdAt: "",
            updatedAt: "",
            asOf: "2024-12-31T00:00:00",
          },
        },
      ],
    },
  ],
  latestAsOf: "2024-12-31T00:00:00",
};
